<template>
  <div class="credittransferpaymentrun-list">
    <Toolbar :handle-add="addHandler" />

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1>{{ $t('CreditTransferPaymentRun List') }}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter" init-expand>
            <CreditTransferPaymentRunFilterForm
              ref="filterForm"
              :values.sync="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            :items-per-page.sync="options.itemsPerPage"
            :loading="isLoading"
            :loading-text="$t('Loading...')"
            :no-results-text="$t('No data available')"
            :no-data-text="$t('No data available')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            :footer-props="{ 'items-per-page-text': $t('Records per page') }"
          >
              <template slot="item.owner" slot-scope="{ item }">
                {{ item['owner'] }}
              </template>

              <template slot="item.creditTransfers" slot-scope="{ item }">
                {{ item['creditTransfers'].length }}
              </template>
              <template v-slot:item.totalAmount="{ item }">
                {{ $n(item['totalAmount']['amount'] / 100, 'currency') }} {{ item['totalAmount']['currency'] }}
              </template>
              <template slot="item.createdAt" slot-scope="{ item }">
                {{ $d(new Date(item['createdAt']), 'short') }}
              </template>
              <template slot="item.processedAt" slot-scope="{ item }">
                {{ item['processedAt'] ? $d(new Date(item['processedAt']), 'short') : '-' }}
              </template>
              <template slot="item.dueAt" slot-scope="{ item }">
                {{ $d(new Date(item['dueAt']), 'short') }}
              </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
              :handle-edit="() => editHandler(props.item)"
              :handle-delete="() => deleteHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import CreditTransferPaymentRunFilterForm from '../../components/credittransferpaymentrun/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';

export default {
  name: 'CreditTransferPaymentRunList',
  servicePrefix: 'CreditTransferPaymentRun',
  mixins: [ListMixin],
  components: {
    Toolbar,
    ActionCell,
    CreditTransferPaymentRunFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('creator'), value: 'owner', sortable: false },
        { text: this.$t('creditTransfers'), value: 'creditTransfers', sortable: false },
        { text: this.$t('totalAmount'), value: 'totalAmount', sortable: false },
        { text: this.$t('createdAt'), value: 'createdAt' },
        { text: this.$t('processedAt'), value: 'processedAt', sortable: false },
        { text: this.$t('dueAt'), value: 'dueAt', sortable: false },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        }
      ],
      selected: []
    };
  },
  created() {
    this.options.sortBy = ['created_at'];
    this.options.sortDesc = [true];
    this.filters = {

    }
  },
  computed: {
    ...mapGetters('credittransferpaymentrun', {
      items: 'list'
    }),
    ...mapFields('credittransferpaymentrun', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('credittransferpaymentrun', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    editHandler(item) {
      this.$router.push({
        name: 'AddTransfersToRunCreate',
        params: { id: item['@id'] }
      });
    }
  }
};
</script>
